import React from 'react';

export const NameListUsers = ({ names }) => {

  return (
    names && names.map((name) => (
      <span key={name} className="hover:bg-white mr-2 text-xs">{name}</span>
    ))
  );
};
